// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Timer-cls1___98fe05e9bc140f4d3a1{/*!*/}.Timer-cls2__ed491908d3114df6715d{display:grid;grid-gap:3px 13px;gap:3px 13px;grid-template-columns:repeat(3, auto);justify-content:center;padding-top:16px}.Timer-cls2__ed491908d3114df6715d.Timer-withoutHours___89cc997d4fdda9f42e2{grid-template-columns:repeat(2, auto)}.Timer-cls2__ed491908d3114df6715d.Timer-mini___e1e8ca49a4483b9799a{grid-gap:3px 8px;gap:3px 8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Timer-cls1___98fe05e9bc140f4d3a1",
	"cls2": "Timer-cls2__ed491908d3114df6715d Timer-cls1___98fe05e9bc140f4d3a1",
	"withoutHours": "Timer-withoutHours___89cc997d4fdda9f42e2",
	"mini": "Timer-mini___e1e8ca49a4483b9799a"
};
export default ___CSS_LOADER_EXPORT___;
